import {Injectable} from '@angular/core';
import {AsyncSubject, Observable} from 'rxjs';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class ConfigurationService {
  private readonly settingsFilePath: string = 'settings.json';
  private readonly configurationFilePath: string = 'config.json';
  private readonly settings$ = new AsyncSubject<any>();
  private readonly configuration$ = new AsyncSubject<any>();

  constructor(private readonly http: HttpClient) {
    this.http.get(this.configurationFilePath).subscribe(config => this.publishConfiguration(config));
    this.http.get(this.settingsFilePath).subscribe(settings => this.publishSettings(settings));
  }

  getConfiguration(): Observable<any> {
    return this.configuration$;
  }

  getSettings(): Observable<any> {
    return this.settings$;
  }
  
  private publishConfiguration(config: any) {
    this.configuration$.next(config);
    this.configuration$.complete();
  }
  
  private publishSettings(settings: any) {
    this.settings$.next(settings);
    this.settings$.complete();
  }
}
